import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BaseStatus from './BaseStatus';
import './UserStatus.css';

class UserStatus extends Component {
  static propTypes = {
    status: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className="user-status">
        <BaseStatus
          labels={[
            {
              id: 'active',
              label: 'active',
            },
            {
              id: 'inactive',
              label: 'inactive',
            },
            {
              id: 'pending_invitation',
              label: 'pending invitation',
            },
          ]}
          status={this.props.status}
        />
      </div>
    );
  }
}

export default UserStatus;



// WEBPACK FOOTER //
// ./src/components/shared/text/UserStatus.js